import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import DistrictAllForms from "../CommonForm";
import { getExistedSchemesAplication, queryApplication, queryFormApplication } from "../../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  AgriProductsAPMC,
  AmendmentStaffMarketCommittee,
  AppointmentSecretaryAPMC,
  BuyingLandAPMC,
  ContractualAppointmentSecretaryAPMC,
  PayComission,
  PermAppointmentSecretaryAPMC,
  PromotionSecretaryMarketCommittee,
  ProposalDonation,
  ProposalLoan,
  SellingLandAPMC,
  StudyTour,
  YardAPMC,
} from "../../../LandDistrict/Json/AllData";

const FormsAuthorityDistrictTable = () => {
  // Redux selectors
  // Define RootState type for useSelector
  interface RootState {
    auth: {
      token: string;
      userDetails: any;
    };
  }
 const navigate = useNavigate();
  const token = useSelector((state: RootState) => state.auth.token);
  const userDetail = useSelector((state: RootState) => state.auth.userDetails);
  const [commentsubmitted, setCommentSubmitted]=useState(false);
  
  // Location for getting applicationId and id
  const location = useLocation();
  const type = location.state?.id;
  
  // State variables
  const [existData, setExistData] = useState(null);
  const [queries, setQueries] = useState([]);
  const [unverifiedFields, setUnverifiedFields] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emptyFields, setEmptyFields] = useState(new Set());
  const [submitAttempted, setSubmitAttempted] = useState(false);
  
  // Get applicationId and id from location state
  const [applicationId, setApplicationID] = useState(location?.state?.applicationId);
  const [id, setId] = useState(location?.state?.id);
  
  const roleIdentifier = userDetail?.Role?.Role_Identifier;

  // Function to extract unverified fields (isVerified === false) - only annexureOne
  const extractUnverifiedFields = (apiData) => {
    const unverified = [];
    
    if (apiData?.annexureOne) {
      Object.keys(apiData.annexureOne).forEach(fieldName => {
        const fieldData = apiData.annexureOne[fieldName];
        
        if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
          const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
          
          // Only include fields where isVerified === false
          if (lastTransaction?.isVerified === false) {
            unverified.push(fieldName);
          }
        }
      });
    }

    return unverified;
  };

  // Function to generate queries from API data (only isVerified === false) - only annexureOne
  const generateQueries = (apiData) => {
    const generatedQueries = [];
    let keyCounter = 1;

    if (apiData?.annexureOne) {
      Object.keys(apiData.annexureOne).forEach(fieldName => {
        const fieldData = apiData.annexureOne[fieldName];

        if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
          const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];

          // Only include fields where isVerified === false
          if (lastTransaction?.isVerified === false) {

            const formFieldData = 

            generatedQueries.push({
              key: keyCounter++,
              annexure: "Annexure 1",
              annexureType: "annexureOne",
              fieldNumber: fieldName, // Using fieldName directly as field number
              comment: lastTransaction.comment || "No comment provided",
              status: "reject",
              checked: false,
              fieldName: fieldName,
              transactionData: lastTransaction,
              standardizedComment: "" // Initialize with empty string
            });
          }
        }
      });
    }

    return generatedQueries;
  };

  // Function to validate all comments are filled
  const validateAllComments = () => {
    const emptyFieldKeys = new Set();
    let hasEmptyFields = false;

    queries.forEach(query => {
      if (!query.standardizedComment || query.standardizedComment.trim() === "") {
        emptyFieldKeys.add(query.key);
        hasEmptyFields = true;
      }
    });

    setEmptyFields(emptyFieldKeys);
    setSubmitAttempted(true);
    return !hasEmptyFields;
  };

  // Function to handle standardized comment changes
  const handleStandardizedCommentChange = (key, value) => {
    setQueries(prev => prev.map(query => 
      query.key === key 
        ? { ...query, standardizedComment: value }
        : query
    ));

    // Remove from empty fields if user starts typing
    if (value.trim() !== "") {
      setEmptyFields(prev => {
        const newSet = new Set(prev);
        newSet.delete(key);
        return newSet;
      });
    } else {
      // Add to empty fields if field becomes empty and submit was attempted
      if (submitAttempted) {
        setEmptyFields(prev => new Set(prev).add(key));
      }
    }
  };

  // Function to prepare rejected field names for API

  const prepareRejectedFieldNames = () => {
     return queries
      .filter(query => query.standardizedComment && query.standardizedComment.trim() !== "")
      .map(query => ({
    fieldUpdated: query.fieldName,
    annexureUpdated: "annexureOne",
    newTransaction: {
      transactionBy: userDetail?.Role?.Role_Identifier,
      status:  "pending",
      appStatusLevel:  existData?.buttonName[0]?.appStatusLevel ,
      newValue:  []
    },
    isVerified: false,
    isUpdated:  true,
    comment: query.standardizedComment || ""
  }));

}
  const prepareRejectedField = () => {
     return queries
     
      .map(query => ({
    key: query.fieldName,
    annexureType: "annexureOne",
  
  }));
  
}
  // Function to handle comment submission
  const handleSubmitComments = async () => {
    try {
      // Check if there are any queries to validate
      if (queries.length === 0) {
        message.warning("No queries found to submit.");
        return;
      }

      // Validate all standardized comments are filled
      const isValid = validateAllComments();
      
      if (!isValid) {
        message.error({
          content: (
            <div>
              <div>Please fill in all standardized comments before submitting.</div>
              <div>સબમિટ કરતા પહેલા કૃપા કરીને બધી પ્રમાણિત ટિપ્પણીઓ ભરો.</div>
            </div>
          ),
          duration: 5,
          style: { marginTop: '0' }
        });
        
        // Scroll to first empty field
        setTimeout(() => {
          const firstEmptyField = document.querySelector('.border-danger');
          if (firstEmptyField) {
            firstEmptyField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            (firstEmptyField as HTMLElement).focus();
          }
        }, 100);
        
        return;
      }

      setIsSubmitting(true);

      // Prepare payload with all validated comments
      const commentsWithText = queries.filter(query => 
        query.standardizedComment && query.standardizedComment.trim() !== ""
      );

     

      const payload = {
        // applicationId: String(applicationId),
        couchId:existData?.applicationDataId,
        // status: existData?.buttonName[0]?.status,
        
        applicationType: "form",
     fieldsToUpdate:prepareRejectedFieldNames()
      };

   

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.dbResult?.ok) {
        message.success({
          content: `Successfully submitted ${commentsWithText.length} standardized comments!`,
          duration: 5
        });
        
        // Reset comments and validation state after successful submission
        // setQueries(prev => prev.map(query => ({
        //   ...query,
        //   standardizedComment: "",
        //   status: "Resolved"
        // })));
        setCommentSubmitted(true);
        
        setEmptyFields(new Set());
        setSubmitAttempted(false);
        
        // Refresh the data
        await getExistedApplication();
        //  navigate("/apmc-forms-application");
      } else {
        message.error("Failed to submit comments. Please try again.");
      }
    } catch (error) {

      message.error("An error occurred while submitting comments. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to get existing application data
  const getExistedApplication = async () => {
    try {
     
      
      const response = await getExistedSchemesAplication(token, applicationId, id);
     

      if (response?.success) {
       
        setExistData(response?.data);
        
      
       
        
        // Generate queries and extract unverified fields (only isVerified === false)
        const generatedQueries = generateQueries(response.data);
        const unverified = extractUnverifiedFields(response.data);
        
        setQueries(generatedQueries);
        setUnverifiedFields(unverified);

      } else {
        message.error("Failed to fetch application data");
      }
    } catch (error) {
  
      message.error("Error occurred while fetching application data");
    }
  };

  // useEffect to fetch data when component mounts
  useEffect(() => {
    if (token && applicationId && id) {
      getExistedApplication();
    }
  }, [token, applicationId, id]);

  // Helper to get the correct dataField array based on type
  let heading = "";
  const getDataField = () => {
  
    const typeNum = Number(type);
    switch (typeNum) {
      case 39:
        heading = "Buying Land";
        return BuyingLandAPMC;
      case 40:
        heading = "Selling Land";
        return SellingLandAPMC;
      case 41:
        heading = "To control Agriculture products under the APMC - Application under Form-8";
        return AgriProductsAPMC;
      case 42:
        heading = "Declaration of the main yard/sub-yard of APMC";
        return YardAPMC;
      case 43:
        heading = " the new/permanent or temporary appointment of the Secretary in the Market Committee";
        return AppointmentSecretaryAPMC;
      case 44:
        heading = "Permanent appointment of Secretary in the Market Committee";
        return PermAppointmentSecretaryAPMC;
      case 45:
        heading = "Regarding amendment in the staff schedule of the Market Committee";
        return AmendmentStaffMarketCommittee;
      case 46:
        heading = "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
        return PromotionSecretaryMarketCommittee;
      case 47:
        heading = "Regarding contractual appointment of Secretary / employee after retirement";
        return ContractualAppointmentSecretaryAPMC;
      case 48:
        heading = "Regarding approval of 7th Pay Commission for Secretary / employee";
        return PayComission;
      case 49:
        heading = " Proposals regarding donation";
        return ProposalDonation;
      case 50:
        heading = "Proposals regarding loan";
        return ProposalLoan;
      case 51:
        heading = "Approval for Study Tours";
        return StudyTour;
     
    }
  };
  const dataField = getDataField();

  // Helper to get fieldNo from fieldName
  const getFieldNo = (fieldName) => {
 
    const found = dataField?.find(item => item.fieldName === fieldName);
  
    return found ? found.fieldNo : fieldName;
  };
  const getField = (fieldName) => {
    
    const found = dataField?.find(item => item.fieldName === fieldName);
    
    return found ? found.fieldVal : fieldName;
  };
  // Table columns configuration
  const columns = [
    {
      title: "Field Number",
      dataIndex: "fieldNumber",
      width: 150,
      render: (text) => (
       <span>{getFieldNo(text)}</span>
      ),
    },
    {
      title: "Field",
      dataIndex: "fieldNumber",
      width: 500,
      render: (text:string) => (
        <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{getField(text)}</span>
      ),
    },
    {
      title: "Comment",
      dataIndex: "comment",
      render: (text) => (
        <div style={{ maxWidth: '400px', wordWrap: 'break-word' }}>
          {text}
        </div>
      ),
    },
    {
      title: "Standardized Comment *",
      dataIndex: "standardizedComment",
      render: (value, record) => {
        const isEmpty = !value || value.trim() === "";
        const showValidation = submitAttempted && emptyFields.has(record.key);
        
        return (
          <div>
            <textarea 
              placeholder="Write Here..." 
              className={`w-100 rounded ${showValidation ? 'border-danger' : ''}`}
              rows={3}
              value={value || ""}
              onChange={(e) => handleStandardizedCommentChange(record.key, e.target.value)}
              style={{
                borderColor: showValidation ? '#dc3545' : '#ced4da',
                borderWidth: showValidation ? '2px' : '1px'
              }}
            />
            {showValidation && (
              <div className="mt-1">
                <span className="text-danger small d-flex align-items-center">
                  <i className="feather feather-alert-circle me-1"></i>
                  Please fill this comment
                </span>
                <span className="text-danger small d-flex align-items-center">
                  <i className="feather feather-alert-circle me-1"></i>
                  કૃપા કરીને આ ટિપ્પણી ભરો
                </span>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  // Calculate counts for display
  const pendingCount = queries.filter((q) => q.status === "reject").length;
  const resolvedCount = queries.filter((q) => q.status === "Resolved").length;
  const totalCount = queries.length;

  return (
    <div className="page-wrapper">
      <div>
        <h2 className="m-3">Application Id - {applicationId || "Loading..."}</h2>
      </div>

      {/* Only show queries section if user has appropriate role */}
      {(roleIdentifier === "JC" || roleIdentifier === "SC") && (
        <div className="m-3 mx-5 card p-3">
          <div className="d-flex justify-content-between">
            <div className="mb-2">
              <h3 className="mb-1">
                <i className="feather feather-message-square text-info"></i>{" "}
                Senior Authority Queries & Comments
              </h3>
              <p className="text-muted">Resolved the given queries</p>
            </div>

            <div className="mb-3">
              <span className="text-warning">●</span> Pending: {pendingCount}
              <span className="text-success ms-3">●</span> Resolved: {resolvedCount}
              <span className="text-primary ms-3">●</span> Total: {totalCount}
            </div>
          </div>

          {queries.length > 0 ? (
            <Table
              columns={columns}
              dataSource={queries}
              bordered
              pagination={false}
            />
          ) : (
            <div className="text-center p-4">
              {existData ? (
                <p className="text-muted">No unverified fields found.</p>
              ) : (
                <p className="text-muted">Loading application data...</p>
              )}
            </div>
          )}

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-info mt-2"
              onClick={handleSubmitComments}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Comments"}
            </button>
          </div>
        </div>
      )}

      {/* Pass unverified fields to child component */}
      <DistrictAllForms 
        unverifiedFields={unverifiedFields}
        userRole={userDetail?.Role?.Role_Identifier}
        existData={existData}
        prepareRejectedField={prepareRejectedField}
        commentsubmitted={commentsubmitted}
      />
      
      {/* <div className="d-flex justify-content-end mb-3 me-5">
        {roleIdentifier === "JC" && (
          <button className="btn btn-info">Submit Again</button>
        )}
      </div> */}
    </div>
  );
};

export default FormsAuthorityDistrictTable;